import queryClient from "single-spa/react-app/query-client";

import { createLeadScoringQueryClient } from "./factory";
import type { ILeadScoringQueryClient } from "./types";

export const leadScoringQueryClient: ILeadScoringQueryClient = createLeadScoringQueryClient({ queryClient });
